module.exports = __webpack_public_path__ + "img/emerald-logo-short.c7c5d731.png";